import React from 'react';
import ReactTooltip from 'react-tooltip';

const WidgetHeader = ({
  handleWidgetCancel,
  openGetCodeModel,
  state,
  profile,
  authToken,
  handleCancelCnf,
  handleUpdateCnf,
  createWidget,
  handleInputchange,
  handleScreenSize,
  redirectPreview,
  wdtLoginCreateWidget,
  confirmForResetWidget,
  widgetId
}) => {
  return (
    <div className="header-editor">
      <div className="header-editor-part header-editor-right">
        {
          profile && profile.brand ?
            profile.brand.lg ?
              <img className="logo-icon" src={profile.brand.lg} alt="notifly" />
              :
              <img className="logo-icon" src='https://storage.googleapis.com/wiserimg/user_img/default_company.png' alt="notifly" />
            :
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="19" viewBox="0 0 35 19">
              <g id="Group_27865" data-name="Group 27865" transform="translate(75.503 -1134.629)">
                <path id="Union_15" data-name="Union 15" d="M18.713,14.956,10.186,3.8a2.307,2.307,0,0,1-.449-1.783,2.358,2.358,0,0,1,1-1.557,2.6,2.6,0,0,1,3.51.529l6.509,8.519,1.753-2.3a2.6,2.6,0,0,1,3.514-.529,2.36,2.36,0,0,1,1,1.557,2.307,2.307,0,0,1-.449,1.783l-3.63,4.753a2.5,2.5,0,0,1-.242.271,2.416,2.416,0,0,1-.488.441,2.6,2.6,0,0,1-3.51-.529Zm-9.706,0L.48,3.8A2.307,2.307,0,0,1,.031,2.014a2.358,2.358,0,0,1,1-1.557,2.6,2.6,0,0,1,3.51.529l8.526,11.159a2.307,2.307,0,0,1,.449,1.783,2.36,2.36,0,0,1-1,1.557,2.6,2.6,0,0,1-3.511-.529Z" transform="translate(-74.999 1136.748)" fill="#212121" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"></path><path id="Polygon_10" data-name="Polygon 10" d="M3.017.311A.772.772,0,0,1,3.625,0a.721.721,0,0,1,.6.3l2.753,3.8a.725.725,0,0,1,.048.765.772.772,0,0,1-.669.41L.73,5.356a.718.718,0,0,1-.656-.391.733.733,0,0,1,.072-.77Z" transform="translate(-46.829 1134.634) rotate(35.025)" fill="#645cfc"></path>
              </g>
            </svg>
        }

        {
          authToken ?//check user login or not
            !state.isEditWidget ? //
              <div className="btn-exit-code">
                <button className="nf-btn nf-btn-noneBdr tbl-seehty-btn nf-btn-minW wg-btn-exit" onClick={() => handleWidgetCancel()}>Exit</button>
                {
                  widgetId &&
                  <div className="wdgt-btn-getcode btn-getcode-prvside">
                    <a className="nf-btn nf-btn-default nf-btn-noneBdr  nf-btn-minW" onClick={() => openGetCodeModel(state.widgetById)} >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18.001" height="12" viewBox="0 0 18.001 12">
                        <g id="Group_27696" data-name="Group 27696" transform="translate(10490 -2962)">
                          <path id="Path_58056" data-name="Path 58056" d="M10.9,0,12,1.071,6,6.923,0,1.071,1.1,0,6,4.782l.065-.063Z" transform="translate(-10478.923 2974) rotate(-90)" fill="#fff" />
                          <path id="Path_58057" data-name="Path 58057" d="M10.9,6.923,12,5.853,6,0,0,5.853,1.1,6.923,6,2.141l.065.063Z" transform="translate(-10490 2974) rotate(-90)" fill="#fff" />
                        </g>
                      </svg>
                      Get Code
                    </a>
                  </div>
                }
              </div>
              :
              widgetId ? //if widget id found in url then edit otherwise create new widget
                <div className="btn-group-dissave">
                  <button className="nf-btn  tbl-seehty-btn nf-btn-noneBdr nf-btn-minW wg-btn-discard" onClick={() => handleCancelCnf()} data-tip data-for="tltpdcrd">
                    Discard
                  </button>
                  <ReactTooltip id="tltpdcrd" aria-haspopup='true' role='example'>
                    <p>Discard your changes</p>
                  </ReactTooltip>
                  <button className="nf-btn nf-btn-green nf-btn-noneBdr nf-btn-minW wg-btn-save" onClick={() => handleUpdateCnf()} data-tip data-for="tltpsvcrd">
                    Save
                  </button>
                  <ReactTooltip id="tltpsvcrd" aria-haspopup='true' role='example'>
                    <p>You must click 'Save' to apply your update</p>
                  </ReactTooltip>
                </div>
                :
                <div className="btn-group-dissave">
                  <button className="nf-btn tbl-seehty-btn nf-btn-noneBdr nf-btn-minW wg-btn-discard" onClick={() => handleCancelCnf()} data-tip data-for="tltpdcrd">
                    Discard
                  </button>
                  <ReactTooltip id="tltpdcrd" aria-haspopup='true' role='example'>
                    <p>Discard your changes</p>
                  </ReactTooltip>
                  <button className="nf-btn nf-btn-green nf-btn-noneBdr nf-btn-minW  wg-btn-save" onClick={() => createWidget()} data-tip data-for="tltpsvcrd">Save</button>
                  <ReactTooltip id="tltpsvcrd" aria-haspopup='true' role='example'>
                    <p>You must click 'Save' to apply your update</p>
                  </ReactTooltip>
                </div>
            :
            <button className="nf-btn nf-btn-green nf-btn-noneBdr nf-btn-minW" onClick={() => wdtLoginCreateWidget()}>Join & Create</button>
        }
        <input placeholder="Wall name" className="wdgt-name-input" value={state.wdsc ? state.wdsc : ''} onChange={(e) => handleInputchange('wdsc', e.target.value)} />
      </div>
      <div className="header-editor-part header-editor-middle">
        <div className="reset-block" >
          <span className="reset-link" onClick={() => confirmForResetWidget()}>Reset</span>
        </div>
        <div className="header-editor-screenicon">
          <div className={!state.isMobileScreen ? 'screen-size active' : 'screen-size'} onClick={() => handleScreenSize('desktop')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 17 17.139">
              <g id="streamline-icon-computer-screen-1_20x20" data-name="streamline-icon-computer-screen-1@20x20" transform="translate(-0.215 -1.286)">
                <path id="Path_21056" data-name="Path 21056" d="M.714,1.786h16V14.308h-16Z" transform="translate(0 0)" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_21057" data-name="Path 21057" d="M8.374,14.643,7.143,18.121" transform="translate(-0.89 -0.335)" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_21058" data-name="Path 21058" d="M11.429,14.643l1.231,3.478" transform="translate(-1.483 -0.335)" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_21059" data-name="Path 21059" d="M5.714,18.214H13.1" transform="translate(-0.692 -0.428)" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
              </g>
            </svg>
          </div>
          <div className={state.isMobileScreen ? 'screen-size active' : 'screen-size'} onClick={() => handleScreenSize('phone')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17">
              <g id="streamline-icon-catergories-phone_20x20" data-name="streamline-icon-catergories-phone@20x20" transform="translate(-3.686 -0.214)">
                <path id="Path_21053" data-name="Path 21053" d="M3.571.714h10v16h-10Z" transform="translate(0.615 0)" fill="none" stroke="#656565" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_59829" data-name="Path 59829" d="M11.036,17.75a1,1,0,1,1,1-1A1,1,0,0,1,11.036,17.75Z" transform="translate(-1.85 -3.036)" fill="#656565" />
              </g>
            </svg>
          </div>
        </div>
        {
          localStorage.getItem('isbusr') !== 'true' &&
          <div className='preview-wrap' onClick={() => redirectPreview()}>
            <span className='preview-item'>
              Preview
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12.001 12">
                <path id="Path_59586" data-name="Path 59586" d="M7.5-14.964a.64.64,0,0,1-.455-.187.64.64,0,0,1-.187-.455.64.64,0,0,1,.187-.455.64.64,0,0,1,.455-.187h3.858a.64.64,0,0,1,.455.187.64.64,0,0,1,.187.455v3.857a.64.64,0,0,1-.187.455.64.64,0,0,1-.455.187.64.64,0,0,1-.455-.187.64.64,0,0,1-.187-.455v-2.3l-5.358,5.3a.587.587,0,0,1-.442.2.587.587,0,0,1-.442-.2.615.615,0,0,1-.188-.442.615.615,0,0,1,.188-.442l5.334-5.334ZM0-13.892a1.609,1.609,0,0,1,.429-1.071A1.609,1.609,0,0,1,1.5-15.392h3a.64.64,0,0,1,.455.187.64.64,0,0,1,.187.455.64.64,0,0,1-.187.455.64.64,0,0,1-.455.187h-3a.231.231,0,0,0-.214.214v8.144a.231.231,0,0,0,.214.214H9.643a.231.231,0,0,0,.215-.214v-3a.64.64,0,0,1,.187-.455.64.64,0,0,1,.455-.187.64.64,0,0,1,.455.187.64.64,0,0,1,.187.455v3a1.609,1.609,0,0,1-.429,1.071,1.609,1.609,0,0,1-1.071.429H1.5A1.609,1.609,0,0,1,.429-4.678,1.609,1.609,0,0,1,0-5.749Z" transform="translate(0 16.249)" fill="#3cca73" />
              </svg>
            </span>
          </div>
        }
      </div>
      <div className="header-editor-part header-editor-left">
        <h1>Widget </h1>
      </div>
    </div>
  );
};

export default WidgetHeader;


// WEBPACK FOOTER //
// ./src/components/Widget/WidgetHeader.js